import * as React from "react";
import {Alert, Button, Modal} from "react-bootstrap/lib";
import {FormattedMessage, InjectedIntlProps} from "react-intl";
import {ErrorDisplay} from "./errordisplay/ErrorDisplay";
import {Spinner} from "./spinner/Spinner";
import {Warning} from "../model";
import {mapWarningToMessage} from "../util/WarningMapper";
import {mapErrorToMessage} from "../util/ErrorMapper";

interface PromptDialogProps {
  title: string;
  renderForm: () => JSX.Element;
  promptButtonText: string;
  promptButtonDisabled?: boolean;
  onSubmit: (event: any) => void;
  executing: boolean;
  executingMessage: string;
  error: Error;
  warnings: Warning[];
  success: boolean;
  successMessage: string;
  onHide: () => void;
  bsStylePrompt?: string;
}

export class PromptDialog extends React.Component<PromptDialogProps & InjectedIntlProps> {

  renderExecuting() {
    const {executing, executingMessage} = this.props;
    if (executing) {
      return (
          <div style={{textAlign: "center"}}>
            <h2>{executingMessage}</h2>
            <Spinner bigStyle/>
          </div>
      );
    }
    return null;
  }

  renderSuccess() {
    const {success, successMessage} = this.props;
    if (success) {
      return (
          <div style={{textAlign: "center"}}>
            <h2>{successMessage}</h2>
          </div>
      );
    }
    return null;
  }

  renderError() {
    const {error} = this.props
    const errorMessage = mapErrorToMessage(error);
    if (errorMessage) {
      return <Alert bsStyle="danger">{errorMessage}</Alert>;
    }
    return <ErrorDisplay error={error}/>;
  }

  renderWarnings() {
    const {warnings, successMessage} = this.props;
    if (warnings) {
      return (
          <div>
            <div style={{textAlign: "center"}}>
              <h2>{successMessage}</h2>
            </div>
            <div>
              <FormattedMessage id="studio.ui.prompt-dialog.warnings-reported" defaultMessage="The following warnings were reported:"/>
              <ul>
                {warnings.map((warning, idx) =>
                    <li key={"warning-response-" + idx}>
                      {mapWarningToMessage(warning)}
                    </li>)}
              </ul>
            </div>
          </div>
      );
    }
    return null;
  }

  renderPrompt() {
    const {renderForm: renderPrompt} = this.props;
    return renderPrompt();
  }

  renderTitle() {
    const {executing, error, warnings, success, title} = this.props;

    if (executing || error || success || warnings) {
      return null;
    }

    return <Modal.Title>{title}</Modal.Title>;
  }

  renderBody() {
    const {executing, error, warnings, success} = this.props;

    if (error) {
      return this.renderError();
    }

    if (warnings) {
      return this.renderWarnings();
    }

    if (success) {
      return this.renderSuccess();
    }

    if (executing) {
      return this.renderExecuting();
    }

    return this.renderPrompt();
  }

  renderButtons() {
    const {executing, onSubmit, promptButtonText, promptButtonDisabled, onHide, success, error, warnings} = this.props;

    if (error || warnings || success) {
      return <Button onClick={onHide}><FormattedMessage id="studio.ui.prompt-dialog.close"
                                                        defaultMessage="Close"/></Button>;
    }

    if (executing) {
      return null;
    }

    return (
        <div>
          <Button disabled={promptButtonDisabled} onClick={onSubmit}>{promptButtonText}</Button>
          <Button onClick={onHide}><FormattedMessage id="studio.ui.prompt-dialog.cancel"
                                                     defaultMessage="Cancel"/></Button>
        </div>
    );
  }

  render() {
    const {onHide, executing} = this.props;

    return (
        <Modal show={true} onHide={onHide} backdrop="static">
          <Modal.Header closeButton={!executing}>
            {this.renderTitle()}
          </Modal.Header>
          <Modal.Body>
            {this.renderBody()}
          </Modal.Body>
          <Modal.Footer>
            {this.renderButtons()}
          </Modal.Footer>
        </Modal>
    );
  }
}